module.exports = __webpack_public_path__ + "app/admin/monitoring/monitoring-2g0C9QZi.html";